import { isSafari } from "@/lib/userAgent.ts"

let squirclePromise: Promise<void> | null = null

declare global {
  var __squircle_ready: boolean | undefined
}

export function loadSquircle() {
  if (squirclePromise) return squirclePromise

  globalThis.__squircle_ready = false

  squirclePromise = (async () => {
    if (isSafari) {
      document.documentElement.style.setProperty("--paint-squircle", "none")
    } else {
      if (!("paintWorklet" in CSS)) {
        // @ts-expect-error Untyped module
        await import("css-paint-polyfill")
      }

      // @ts-expect-error Untyped module
      CSS.paintWorklet.addModule("https://www.unpkg.com/css-houdini-squircle/squircle.min.js")
        .then(() => globalThis.__squircle_ready = true)
        .catch(() => console.log("paintWorklet failed to load"))
    }
  })()

  return squirclePromise
}
